<button class="btn {{colorCssClass}} btn-two-lines {{extraClasses}} btn-two-lines-size-{{size}}"
        [disabled]="disabled"
        (click)="onClick.emit()">
  <div class="d-flex justify-content-center align-items-center">
    <i class="{{icon}} me-2 btn-two-lines-icon"></i>
    <span class="btn-two-lines-title">{{title}}</span>
  </div>

  <div class="btn-two-lines-info-text fw-normal" *ngIf="info">{{info}}</div>

  <ng-content select=".btn-two-lines-info"></ng-content>
</button>

<ng-content select="ui-btn-hint"></ng-content>
